import env from './env';

/**
 * [domainApi]
 * @return {[string]} - return the api base URL based on the environment the request is made
 */
function domainApi() {
  if (!env.isNode() && window.API_MANIFEST && window.API_MANIFEST.apiURL) {
    return window.API_MANIFEST.apiURL;
  }
  return '';
}

export default domainApi;
